<template>
    <div
        class="forgot-pw-page locale-font"
        :style="{'background-image': `url(${require('@/assets/login-bg.jpg')})`}">
        <div class="top-left-logo">
            <img src="@/assets/logo-trans.png" />
        </div>
        <div class="top-right-lang">
            <ChangeLang />
        </div>
        <v-card
            width="570"
            outlined>
            <div v-if="state === 'input-email'">
                <v-card-text class="card-input">
                    <div class="header-forgot-pw">
                        {{ $vuetify.lang.t('$vuetify.forgotPassword.forgotYourPassword') }}
                    </div>
                    <div class="sub-header-forgot-pw">
                        {{ $vuetify.lang.t('$vuetify.forgotPassword.textResetYourPassword') }}
                    </div>
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        v-on:submit.prevent>
                        <v-text-field
                            :label="this.$vuetify.lang.t('$vuetify.forgotPassword.emailAddress')"
                            v-model="form.email"
                            type="text"
                            :placeholder="this.$vuetify.lang.t('$vuetify.forgotPassword.enterYourEmailAddress')"
                            v-on:keyup.enter="onSubmit()"
                            :rules="emailRules"
                            :error-messages="errors.email"
                        ></v-text-field>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-row>
                        <v-col cols="12 flex-center">
                            <v-btn
                                class="mx-auto my-5"
                                width="264"
                                color="primary"
                                @click="onSubmit()">
                                {{ $vuetify.lang.t('$vuetify.forgotPassword.sendEmail') }}
                            </v-btn>
                        </v-col>
                        <v-col cols="12 flex-center pt-0">
                            <span
                                class="back-to-login"
                                @click="goToLoginPage()">
                                {{ $vuetify.lang.t('$vuetify.forgotPassword.returnToLogIn') }}
                            </span>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </div>
            <div v-else-if="state === 'sent-email'">
                <v-card-text class="card-input">
                    <div class="header-forgot-pw">
                        <i class="icon-header fas fa-check-circle mr-3"></i>
                        {{ $vuetify.lang.t('$vuetify.forgotPassword.emailSent') }}
                    </div>
                    <div class="sub-header-forgot-pw">
                        {{ $vuetify.lang.t('$vuetify.forgotPassword.resetPasswordLink') }}

                        <br>

                        <span class="sent-email">
                            {{ form.email }}
                        </span>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-btn
                        class="mx-auto my-5"
                        width="264"
                        color="primary"
                        @click="notThisEmail()">
                        {{ $vuetify.lang.t('$vuetify.forgotPassword.notThisEmail') }}
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </div>
</template>
<script>
import ChangeLang from '@/components/ChangeLang'

export default {
    name: 'ForgotPassword',

    components: {
        ChangeLang
    },

    data () {
        return {
            valid: true,
            form: {
                email: ''
            },
            loading: false,
            errors: {},
            emailRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.forgotPassword.emailAddressIsRequired'),
                v => (/\S+@\S+\.\S+/).test(v) || this.$vuetify.lang.t('$vuetify.forgotPassword.emailAddressIsNotValid')
            ],
            state: 'input-email' // two possible states, input-email and sent-email
        }
    },

    methods: {
        async onSubmit () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.$store.dispatch('setLoading', true)

            const res = await this.axios.post('user/forget-password', this.form)

            if (res && res.data) {
                if (res.data.status === 'ok') {
                    this.state = 'sent-email'
                } else if (res.data.status === 'error_inputs') {
                    this.errors = res.data.errors
                }
                this.$store.dispatch('setLoading', false)
            }
        },

        goToLoginPage () {
            this.$router.push({ name: 'Login' }, () => {})
        },

        notThisEmail () {
            this.form.email = ''
            this.state = 'input-email'
        }
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                this.$utils.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.forgot-pw-page {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    .v-content {
        height: 100%;
    }
}
.header-forgot-pw {
    margin-top: 2rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    font-size: 24px;
    font-weight: 500;
}
.sub-header-forgot-pw {
    margin-bottom: 1rem;
    font-weight: 500;
    text-align: center;
}
.card-input {
    padding: 0rem 5rem;
}
.back-to-login {
    margin-bottom: 1.5rem;
    cursor: pointer;
    color: #D76436;
    font-weight: 500;
}
.flex-center {
    display: flex;
    justify-content: center;
}
.sent-email {
    color: #D76436;
}
.icon-header {
    color: #139888;
}
.top-left-logo {
    position: fixed;
    top: 34px;
    left: 5%;

    img {
        width: 98px;
        height: 130px;
    }
}
</style>
